module.exports = __webpack_public_path__ + "img/DW365-051.6fbe3192.jpg";